import { useCallback } from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  postAuthenticationVerify,
  PostAuthenticationVerifyParams,
} from '../../actions/auth/postAuthenticationVerify/postAuthenticationVerify.actions';
import { resetRequest } from '../../actions/requests';
import { AUTHENTICATION_VERIFY_POST_REQUEST_KEY } from '../../constants';
import { ReduxState } from '../../reducers';
import { getRequestStates } from '../../selectors';

export type UsePostAuthenticationVerifyParams = PostAuthenticationVerifyParams;
export const usePostAuthenticationVerify = () => {
  const postAuthenticationVerifyRequestState = (state: ReduxState) =>
    getRequestStates(
      state,
      AUTHENTICATION_VERIFY_POST_REQUEST_KEY
    );

  const {
    error,
    errorMessage,
    isFetching,
    isSuccess,
  } = useSelector(postAuthenticationVerifyRequestState);
  const dispatch = useDispatch();

  const execute = (
    requestData: UsePostAuthenticationVerifyParams
  ) => {
    dispatch(postAuthenticationVerify(requestData));
  };

  const reset = () => {
    dispatch(
      resetRequest(AUTHENTICATION_VERIFY_POST_REQUEST_KEY)
    );
  };

  return {
    error,
    errorMessage,
    isLoading: isFetching,
    isSuccess,
    execute,
    reset: useCallback(reset, [dispatch]),
  };
};
